import React from "react";

//style import
import "./userProjectsDone.scss";

//Component import
import { UserProjectCard } from "../UserProjectCard/UserProjectCard";
import { IUserAllProjects } from "../../../interfaces/interfaces";

interface Props {
  data: IUserAllProjects[];
}

export const UserProjectsDone: React.FC<Props> = ({ data }) => {
  return (
    <>
      {data.length === 1 ? (
        <div className="UserProjectsDoneContainerSingle">
          {data.map((item, index) => {
            return <UserProjectCard data={item} key={index} />;
          })}
        </div>
      ) : (
        <div className="UserProjectsDoneContainerMultiple">
          {data.map((item, index) => {
            return <UserProjectCard data={item} key={index} />;
          })}
        </div>
      )}
    </>
  );
};
